<template>
  <div class="VisitorTest">
    <el-container>
      <el-header class=" Header">
        <div style="color: rgba(132, 219, 211, 1);font-size: 28px; padding-left:20px;margin-top:30px;">
          管理员已为你发布了测评量表！
        </div>
        <div style="color: rgba(132, 219, 211, 1);font-size: 24px; padding-left:20px;margin-top:10px;">
          快完成下面的测评吧
        </div>
      </el-header>
      <el-main>
        <el-row :gutter="20" style="overflow-y: auto;">
          <div v-for="(item, index) in tableData" :key="index">
            <el-col :sm="8" :offset="index % 2 == 1 ? 2 : 1">
              <div class="paperName">
                {{ item.PaperName }}
              </div>
            </el-col>
            <el-col :sm="2">
              <div class="paperButton" @click="handleEdit(index, item)">
                开始测试
              </div>
            </el-col>
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  mounted() {
    this.loading(1, '')
  },
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    handleEdit(index, row) {
      let nowDate = new Date()
      let year = nowDate.getFullYear()

      if (
        row.PaperID === 'EPQA' &&
        year - moment(this.Global.birthday).year() < 16
      ) {
        //成人版
        this.$message({
          type: 'error',
          message: '年龄小于16岁,请选择少年版',
        })
        return
      }

      if (
        row.PaperID === '(EPQC)' &&
        year - moment(this.Global.birthday).year() > 15
      ) {
        //少年版
        this.$message({
          type: 'error',
          message: '年龄大于16岁,请选择成人版',
        })
        return
      }

      if (row.PaperID === 'WAIS-RC_KJ') {
        this.$router.push({
          path: '/PaperTest/PaperTest_WebsterSpeech',
          query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      } else if (row.PaperID === 'WMS') {
        this.$router.push({
          path: '/PaperTest_WebsterMemory',
          query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      } else if (row.PaperID === 'WAIS-RC') {
        this.$router.push({
          path: '/PaperTest_WebsterAdult',
          query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      } else {
        this.$router.push({
          path: '/Client/PaperTest',
          query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      }
    },
    loading(num, PaperName) {
      this.pageIndex = num
      this.loadings = true
      this.$Http_Post('ScaleIssue/GetvisitorWaitText', {
        token: this.$cookies.get('token'),
        pageSize: '40',
        pageIndex: num,
        PaperName: PaperName,
      })
        .then((res) => {
          this.loadings = false
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data
            this.Counts = Number(res.Counts)
          } else {
            this.Global.request_failure(res.Message)
            this.loading = false
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          })
        })
    },
  },
}
</script>
<style>
.VisitorTest {
  padding: 0px 100px;
  height: 100%;
  background-image: url('../../assets/img_body_bg.png');
}

.VisitorTest .Header {
  margin-top: 20px;
  background-size: 100% 100%;
  height: 131px !important;
  background-position-x: center;
  background-repeat: no-repeat;
  background-image: url('../../assets/img_ceping_home_img01.png');
}

.VisitorTest .el-container .el-header {
  border-bottom: 1px solid #f1f1f100 !important;
}

.VisitorTest .paperName {
  margin-top: 20px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-image: url('../../assets/img_content_bg.png');
  background-size: 100% 100%;
  color: rgba(234, 224, 135, 1);
  font-size: 18px;
}

.VisitorTest .paperButton {
  margin-top: 20px;
  color: rgba(132, 219, 211, 1);
  font-size: 16px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-image: url('../../assets/btn_play_bg.png');
  background-size: 100% 100%;
}

.VisitorTest .el-col {
  padding: 0px !important;
}
</style>
